import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconReframe: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconReframe"><Path d="M7.25 4.09739L12 1.35498L16.75 4.09739M21.5 12.3246V17.8095L16.75 20.5519M7.25 20.5519L2.5 17.8095V12.3246" stroke="currentColor" strokeLinecap="square"/><Path d="M12 2V12M12 12L3 17.5037M12 12L20.9939 17.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconReframe;
